import btn from './lib/btn';
import radio from './lib/radio';
import checkbox from './lib/checkbox';
import onoff from './lib/switch';
import loading from './lib/loading';
import upload from './lib/upload';
import table from './lib/table';
import tabs from './lib/tabs';
import alert from './lib/alert';
import tag from './lib/tag';
import confirm from './lib/confirm';
import message from './lib/message';
import tooltip from './lib/tooltip';
import popover from './lib/popover';
import dropdown from './lib/dropdown';
import select from './lib/select';
import modal from './lib/modal';
import rate from './lib/rate';
import autocomplete from './lib/autocomplete';
import crop from './lib/crop';

export {
  btn,
  radio,
  checkbox,
  onoff,
  loading,
  upload,
  table,
  tabs,
  alert,
  tag,
  confirm,
  message,
  tooltip,
  popover,
  dropdown,
  select,
  modal,
  rate,
  autocomplete,
  crop
};



//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/codeages-design.js
// module id = 327
// module chunks = 9